import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import RiEvMedico from './components/rievMedico';

export default function index() {
  return (
    <>
      <MainContent
        titulo='Carga de evoluciones médicos / Resumen de ingreso'
        component={<RiEvMedico />}
        tableMaxWidth
      />
      
      <Outlet />
    </>
  );
}